module.exports = __webpack_public_path__ + "ac544f00958537a1948fd17bb4ed79c5.png";